import { Card, Container, ListGroup, Table } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import CardHeader from "react-bootstrap/esm/CardHeader"
import PageHeader from "../components/PageHeader"
import Unauthorized from "../components/Unauthorized";
import { useSelector } from "react-redux";

const Reports = () => {
    const navigate = useNavigate()
    const myShipper = useSelector((state) => state.slice.SHIPPER);

    const list = [
        { name: "Billing Report", url: "billing" },
        { name: "Service Summary Report", url: "services" }
    ]
    if (myShipper.role === 'VIEWER') return <Unauthorized />
    return (
        <>
            <PageHeader name='Reports' shipperLabel={"PHOX HEALTH"}>
            </PageHeader>
            <Container className="mx-0">
                <Card style={{ width: "70%" }}>
                    <CardHeader>
                        Reports
                    </CardHeader>
                    <Table responsive size='sm' className='mb-0 ' >
                        <thead>
                            <tr>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((item) => (
                                <tr className="cursor-pointer" onClick={() => { navigate(item.url) }}>
                                    <td>{item.name}</td>
                                </tr>))}

                        </tbody>
                    </Table>
                </Card>
            </Container>
        </>
    )
}

export default Reports